import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge/fire-analytics/fire-analytics';

import { SearchResultStatus, type SearchResultType } from './types';

const HELP_OBJECT_SEARCH_ANALYTIC_SOURCE = 'helpObjectSearch';

interface UseSearchResultAnalyticsProps {
	resultCount: number;
	resultStatus: SearchResultStatus;
	resultType: SearchResultType;
}

export const useSearchResultAnalytics = ({
	resultCount,
	resultStatus,
	resultType,
}: UseSearchResultAnalyticsProps): void => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const lastReportedStatus = useRef<SearchResultStatus>(SearchResultStatus.Pending);

	useEffect(() => {
		if (
			resultStatus === SearchResultStatus.Pending ||
			lastReportedStatus.current === resultStatus
		) {
			return;
		}

		lastReportedStatus.current = resultStatus;

		fireOperationalAnalytics(
			createAnalyticsEvent({ source: HELP_OBJECT_SEARCH_ANALYTIC_SOURCE }),
			`searchResults ${resultStatus === SearchResultStatus.Error ? 'failed' : 'resolved'}`,
			{ resultCount, resultType },
		);
	}, [createAnalyticsEvent, resultCount, resultStatus, resultType]);
};
